import { render, staticRenderFns } from "./PreviewProject.vue?vue&type=template&id=5240d9a9&scoped=true&"
import script from "./PreviewProject.vue?vue&type=script&lang=js&"
export * from "./PreviewProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240d9a9",
  null
  
)

export default component.exports